// removed by extract-text-webpack-plugin
module.exports = {"BackToTop":"BackToTop__BackToTop__1MwKe","hide":"BackToTop__hide__2V6OX","show":"BackToTop__show__203Gf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/BackToTop/BackToTop.css
// module id = 459
// module chunks = 0